var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "@/lib/utils";
const Textarea = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (_jsx("textarea", Object.assign({ className: cn("flex min-h-[80px] w-full rounded-lg border border-border-base bg-background-base px-3 py-2 f-14-400-16 text-text-primary placeholder:text-text-secondary outline-none tr-all hover:border-border-base-hover focus-visible:border-border-base-active focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:border-border-base-disabled disabled:bg-background-base-disabled disabled:text-text-tertiary disabled:placeholder:text-text-tertiary", className), ref: ref }, props)));
});
Textarea.displayName = "Textarea";
export { Textarea };
